<!-- <div *ngIf="legacy" class="flex  flex-row items-center justify-between px-7 rounded-md bg-zen-lite bg-opacity-5 h-20">
    <div class="flex  flex-row items-center w-full">
        <div class="flex flex-row items-center exp gap-3.5">
            <div #trigger class="h-10 relative">
                <a #button (click)="openFilters()"
                    class="btn white leading-10 h-10  px-4 rounded-3xl block maxFBox gap-1"><i class="far fa-plus"></i>
                    {{ "txt_AddFilter_176" | translate:language:ModuleNames.Common }}</a>
            </div>
            <div class="w-8	h-20" [ngClass]="(language|language) ? 'divide-rbar':'divide-lbar'"></div>
        </div>
        <div class="flex flex-row  items-center gap-2.5 h-18 w-full overflow-x-overlay diV-bar"
            *ngIf="barFilters$ | async as barFilters">
            <ng-container *ngFor="let entity of barFilters.entities ;let i=index">
                <div class="flex flex-row text-sm group relative">
                    <a [ZMenuTriggerFor]="menu" class="btn white leading-10 px-4 rounded-3xl maxFBox"
                        [ngClass]="{'pointer-events-none':entity?.nodes?.length == 1}">
                        <span class="capitalize">{{entity.name| extract:language}}</span>
                        <span class="capitalize py-0.5 px-1 mx-1 bg-exp rounded text-white text-xs truncate ...">
                            {{entity?.nodes?.length > 1? entity?.nodes.length : entity?.nodes[0].name | extract:language
                            }}
                        </span>
                    </a>
                    <z-menu #menu>
                        <menuItems>
                            <a *ngFor="let node of entity?.nodes let z=index"
                                class="flex flex-row bg-zen bg-opacity-5 text-zen  leading-8 px-2.5 items-center rounded pointer-events-none"
                                MenuItem>
                                {{node.name | extract:language}}
                            </a>
                        </menuItems>
                    </z-menu>
                    <div class="flex flex-row absolute -top-1  -left-1 -right-1 justify-end h-0">
                        <i (click)="removeGroupFilter(entity.key)"
                            class="fal fa-times text-xxs btn w-3 h-3 min-w-max text-center rounded-full bg-zen-red bg-opacity-20 text-zen-red leading-3 opacity-0 group-hover:opacity-100"></i>
                    </div>
                </div>
            </ng-container>

            <ng-container *ngFor="let filter of barFilters.filters; let i=index">
                <div class="flex flex-row text-sm group relative">
                    <a class="btn white leading-10 px-4 rounded-3xl maxFBox" [ZMenuTriggerFor]="menu1">
                        <span class="capitalize">{{(filter.name| extract:language) ||
                            (filter.name|
                            translate:language:ModuleNames.Shared)}}</span>
                        <span class="capitalize py-0.5 px-1 mx-1 bg-exp rounded text-white text-xs truncate ...">
                            {{filter.value?.length}}
                        </span>


                    </a>
                    <z-menu #menu1>
                        <menuItems>
                            <ng-container *ngFor="let option of filter.validOptions let z=index">
                                <a *ngIf="filter.value?.includes(option.key)"
                                    class="flex flex-row bg-zen bg-opacity-5 text-zen  leading-8 px-2.5 items-center rounded pointer-events-none"
                                    MenuItem>
                                    {{filter.key != 'PerformanceRate'? (option.name
                                    |extract:language):option.value}}
                                </a>
                            </ng-container>
                        </menuItems>
                    </z-menu>
                    <div class="flex flex-row absolute -top-1  -left-1 -right-1 justify-end h-0">
                        <i (click)="removeFilter(filter.key)"
                            class="fal fa-times text-xxs btn w-3 h-3 min-w-max text-center rounded-full bg-zen-red bg-opacity-20 text-zen-red leading-3 opacity-0 group-hover:opacity-100"></i>
                    </div>
                </div>
            </ng-container>


        </div>
        <div class="flex flex-row items-center gap-3.5" [ngClass]="(language|language)  ?'mr-auto':'ml-auto'">
            <div class="w-8	h-20" [ngClass]="(language|language) ? 'divide-lbar':'divide-rbar'"></div>
            <a (click)="resetFilters()"
                class="btn bg-zen-red bg-opacity-5 text-zen-red leading-10 h-10  px-4 rounded-3xl block maxFBox">{{
                "txt_ResetFilt_877" | translate:language:ModuleNames.Common }}</a>
        </div>
    </div>
</div> -->

<ng-container>
    <div
        class="flex flex-row items-center justify-between h-20 px-4 gap-5 rounded-lg border border-zen-neutralp90 bg-zen-neutralp95">
        <div class="w-full flex flex-row items-center">

            <ng-container *ngIf="barFilters$ | async as barFilters">
                <div *ngIf="barFilters.filters?.length > 0 || barFilters.entities?.length > 0"
                    class="flex items-center justify-start gap-4 w-full">
                    <div class="relative flex flex-row flex-wrap justify-start items-start gap-2 w-full">

                        <ng-container
                            *ngFor="let item of (barFilters.filters).concat(barFilters.entities); let i = index">
                            <div>
                                <a class="pl-2 pr-1 btn flex flex-row gap-2 items-center rounded-full justify-center h-6 leading-6 text-xs font-medium text-exp bg-exp bg-opacity-10 hover:bg-exp hover:text-white"
                                    (mouseenter)="hoveredFilterIndex = i; logData(item)"
                                    (mouseleave)="hoveredFilterIndex = null">
                                    <p class="pr-1 py-1">{{( item.name | extract: language )|| item.name}}</p>
                                    <div
                                        class="flex gap-2 justify-center items-center px-1 h-4 rounded-full bg-exp bg-opacity-10">
                                        {{ item?.nodes ? item?.nodes?.length : item?.value?.length }}
                                    </div>
                                </a>
                                <div *ngIf="hoveredFilterIndex === i"
                                    class="absolute mt-0.5 z-50 bg-white border border-zen border-opacity-10 rounded shadow-lg flex flex-col justify-center gap-0.5 items-start p-1.5">
                                    <ng-container *ngIf="item?.nodes?.length > 0; else valueLoop">
                                        <ng-container *ngFor="let option of item.nodes">
                                            <p class="px-1.5 py-1 text-primary-light text-xs font-normal w-full">
                                                {{ option.name | extract: language }}
                                            </p>
                                        </ng-container>
                                    </ng-container>
                                    <ng-template #valueLoop>
                                        <ng-container *ngFor="let option of item?.validOptions">
                                            <p *ngIf="item.value?.includes(option.key)"
                                                class="px-1.5 py-1 text-primary-light text-xs font-normal w-full">
                                                {{(option.name |extract)??option.value}}
                                            </p>
                                        </ng-container>
                                    </ng-template>

                                </div>
                            </div>
                        </ng-container>
                    </div>
                </div>
            </ng-container>

        </div>
        <div class="flex flex-row items-stretch gap-4 min-w-fit">
            <ng-content></ng-content>
            <ng-container *ngIf="showFilterButton">
                <span class="w-px h-10 bg-zen-neutralp90"></span>
                <button zenButton styles="ghost icon-10" (click)="openFilters()">
                    <i class="fa-regular fa-sliders"></i>
                </button>
                <ng-container *ngIf="hasFilters">
                    <button zenButton styles="delete icon-10" (click)="resetFilters()"
                        class="flex justify-start items-start hover:bg-zen-red hover:text-white">
                        <i class="fa-regular fa-xmark hover:text-white"></i> </button>
                </ng-container>
            </ng-container>
        </div>
    </div>
</ng-container>